import * as swcHelpers from '@swc/helpers';
import { DataLayer, calcPrice } from '@grandvisionhq/analytics';

const getPurchaseType = (lineItem)=>{
    if (lineItem.type === 'contact-lenses' || lineItem.type === 'solutions') {
        return lineItem.isSubscription ? DataLayer.DataLayerTypes.PurchaseType.Subscription : DataLayer.DataLayerTypes.PurchaseType.OneTime;
    }
    if (lineItem.type === 'contact-lenses-bundle-benelux') {
        return DataLayer.DataLayerTypes.PurchaseType.CLBBSubscription;
    }
    return DataLayer.DataLayerTypes.PurchaseType.OneTime;
};
const getLineItemType = (lineItem)=>{
    if (lineItem.type === 'contact-lenses' || lineItem.type === 'solutions') {
        return lineItem.isSubscription ? DataLayer.DataLayerTypes.LineItemType.Subscription : DataLayer.DataLayerTypes.LineItemType.Single;
    }
    if (lineItem.type === 'contact-lenses-bundle-benelux') {
        return DataLayer.DataLayerTypes.LineItemType.Bundle;
    }
    return DataLayer.DataLayerTypes.LineItemType.Single;
};
const getSharedAttributes = (lineItem, quantity = 1)=>{
    const { sku , price  } = lineItem;
    const isOnStock1 = lineItem.availability && Object.values(lineItem.availability.channels).some(({ isOnStock , availableQuantity  })=>isOnStock && availableQuantity > 0
    );
    const exclusiveBrand = Boolean(lineItem.brand.exclusive);
    return {
        name: lineItem.name,
        id: sku,
        price: calcPrice(price.unit.gross),
        dimension143: getPurchaseType(lineItem),
        dimension144: getLineItemType(lineItem),
        dimension145: 'true',
        dimension190: lineItem.erpId || '',
        dimension193: exclusiveBrand ? DataLayer.DataLayerTypes.BrandType.OwnBrand : DataLayer.DataLayerTypes.BrandType.ExternalBrand,
        dimension194: isOnStock1 ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock,
        metric140: calcPrice(price.unit.original),
        metric141: calcPrice(price.unit.discount),
        metric142: calcPrice(price.unit.taxAmount),
        quantity
    };
};
const getSunglassesAttributes = (lineItem, quantity)=>{
    var ref, ref1, ref2, ref3, ref4;
    const { brand , frame , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        category: DataLayer.DataLayerTypes.Category.Sunglasses,
        brand: brand.name || '',
        variant: (frame === null || frame === void 0 ? void 0 : (ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: (frame === null || frame === void 0 ? void 0 : (ref1 = frame.frameMaterial) === null || ref1 === void 0 ? void 0 : ref1.join().toLowerCase()) || '',
        dimension147: (frame === null || frame === void 0 ? void 0 : (ref2 = frame.frameColor) === null || ref2 === void 0 ? void 0 : ref2.join().toLowerCase()) || '',
        dimension191: (frame === null || frame === void 0 ? void 0 : (ref3 = frame.frameType) === null || ref3 === void 0 ? void 0 : ref3.toLocaleLowerCase()) || '',
        dimension192: (frame === null || frame === void 0 ? void 0 : (ref4 = frame.faceShape) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || ''
    });
};
const getReadyReadersAttributes = (lineItem, quantity = 1)=>{
    var ref, ref5, ref6, ref7, ref8;
    const { brand , frame , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        category: DataLayer.DataLayerTypes.Category.ReadyReaders,
        brand: brand.name || '',
        variant: (frame === null || frame === void 0 ? void 0 : (ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: (frame === null || frame === void 0 ? void 0 : (ref5 = frame.frameMaterial) === null || ref5 === void 0 ? void 0 : ref5.join().toLowerCase()) || '',
        dimension147: (frame === null || frame === void 0 ? void 0 : (ref6 = frame.frameColor) === null || ref6 === void 0 ? void 0 : ref6.join().toLowerCase()) || '',
        dimension191: (frame === null || frame === void 0 ? void 0 : (ref7 = frame.frameType) === null || ref7 === void 0 ? void 0 : ref7.toLocaleLowerCase()) || '',
        dimension192: (frame === null || frame === void 0 ? void 0 : (ref8 = frame.faceShape) === null || ref8 === void 0 ? void 0 : ref8.toLowerCase()) || ''
    });
};
const getAccessoriesLineItem = (lineItem, quantity = 1)=>{
    const { brand , accessoryType , accessoryColor , material , gender , sku  } = lineItem;
    const genderValue = gender && gender.map((value)=>value.toLowerCase()
    ).join();
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        category: DataLayer.DataLayerTypes.Category.Accessories,
        brand: brand.name || '',
        variant: accessoryType || '',
        dimension16: genderValue || '',
        dimension140: sku,
        dimension146: material || '',
        dimension147: (accessoryColor === null || accessoryColor === void 0 ? void 0 : accessoryColor.join().toLowerCase()) || ''
    });
};
const getContactLensesAttributes = (lineItem, quantity)=>{
    var ref, ref9;
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        name: lineItem.name,
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        brand: lineItem.brand.name || '',
        variant: lineItem.lensType || '',
        dimension140: lineItem.sku,
        dimension146: lineItem.material || '',
        dimension148: ((ref = lineItem.replacementFrequency) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        deliveryInterval: (ref9 = lineItem.subscriptionDetails) === null || ref9 === void 0 ? void 0 : ref9.deliveryInterval
    });
};
const getSolutionsAttributes = (lineItem, quantity)=>{
    var ref;
    return swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        name: lineItem.name,
        category: DataLayer.DataLayerTypes.Category.Solutions,
        brand: lineItem.brand.name || '',
        variant: lineItem.solutionVolume + 'ml',
        dimension140: lineItem.sku,
        dimension146: lineItem.solutionType,
        deliveryInterval: (ref = lineItem.subscriptionDetails) === null || ref === void 0 ? void 0 : ref.deliveryInterval
    });
};
const getContactLensesBundleBeneluxAttributes = (lineItem, quantity)=>swcHelpers.objectSpread({}, getSharedAttributes(lineItem, quantity), {
        category: DataLayer.DataLayerTypes.Category.ContactLenses,
        variant: lineItem.lensType
    })
;
const getPrescriptionGlassesAttributes = (lineItem, quantity = 1)=>{
    var ref, ref10, ref11, ref12;
    const { frame , price , productType  } = lineItem;
    const { brand  } = frame;
    const category = productType === 'sunglasses' ? DataLayer.DataLayerTypes.Category.Sunglasses : DataLayer.DataLayerTypes.Category.Optical;
    const name = lineItem.frame.name || '';
    const isOnStock2 = lineItem.availability && Object.values(lineItem.availability.channels).some(({ isOnStock , availableQuantity  })=>isOnStock && availableQuantity > 0
    );
    const exclusiveBrand = Boolean(brand.exclusive);
    return {
        category,
        name,
        brand: frame.brand.name || '',
        id: frame.sku,
        price: calcPrice(price.unit.gross),
        variant: ((ref = frame.frameShape) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || '',
        dimension16: ((ref10 = frame.gender) === null || ref10 === void 0 ? void 0 : ref10.toLowerCase()) || '',
        dimension140: frame.sku,
        dimension143: getPurchaseType(lineItem),
        dimension144: DataLayer.DataLayerTypes.LineItemType.Bundle,
        dimension145: 'true',
        dimension146: frame.frameMaterial || '',
        dimension147: frame.frameColor || '',
        dimension190: lineItem.erpId || '',
        dimension191: ((ref11 = frame.frameType) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase()) || '',
        dimension192: ((ref12 = frame.faceShape) === null || ref12 === void 0 ? void 0 : ref12.toLowerCase()) || '',
        dimension193: exclusiveBrand ? DataLayer.DataLayerTypes.BrandType.OwnBrand : DataLayer.DataLayerTypes.BrandType.ExternalBrand,
        dimension194: isOnStock2 ? DataLayer.DataLayerTypes.Stock.InStock : DataLayer.DataLayerTypes.Stock.OutOfStock,
        metric140: calcPrice(price.unit.original),
        metric141: calcPrice(price.unit.discount),
        metric142: calcPrice(price.unit.taxAmount),
        quantity
    };
};
const mapClientModelToProductObject = (lineItem, quantity)=>{
    switch(lineItem.type){
        case 'sunglasses':
            return getSunglassesAttributes(lineItem, quantity);
        case 'contact-lenses':
            return getContactLensesAttributes(lineItem, quantity);
        case 'solutions':
            return getSolutionsAttributes(lineItem, quantity);
        case 'contact-lenses-bundle-benelux':
            return getContactLensesBundleBeneluxAttributes(lineItem, quantity);
        case 'prescription-glasses':
            return getPrescriptionGlassesAttributes(lineItem, quantity);
        case 'ready-readers':
            return getReadyReadersAttributes(lineItem, quantity);
        case 'accessories':
            return getAccessoriesLineItem(lineItem, quantity);
        default:
            return undefined;
    }
};

export { mapClientModelToProductObject };
//# sourceMappingURL=client-model-to-product-object.js.map
